import create from 'zustand';
import { ILogin, ILoginInitialState, ILoginState } from '../model/LoginModel';
import { GetCustomerDetailService, GetMasterDetailService, PostLoginService } from '../services/login-service';
import { SessionStorage } from '../services/storage';
import { responseData } from './common';
import { LIFE_SCIENCE_PRODUCT_IDS, TWO_HUNDRED_SUCCESS_CODE } from '../utils/common';
import { GetBookingDetailsService } from '../services/booking-service';


const initialValue: ILoginInitialState = {
    loggedInDetails: {},
    customerDetail: {},
    appStorage: {},
    isLifeScienceCustomer: false
}

let LoginStore = create<ILoginState>((set, get) => ({
    ...initialValue,
    PostLoginAction: async (userDetails: ILogin) => {
        const response = await PostLoginService(userDetails);
        sessionStorage.setItem('token', ((response?.data?.accessToken!) || '{}'));
        set({ loggedInDetails: response?.data })
    },
    GetCustomerDetailAction: async () => {
        const response = await GetCustomerDetailService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE && response?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.CheckIsLifeScienceCustomerAction(response?.data?.data?.subClientId);
        }
        SessionStorage.setObject('customer', (responseData(response?.data) || '{}'));
        set({ customerDetail: responseData(response?.data) })
    },
    GetMasterDetailAction: async () => {
        const response = await GetMasterDetailService();
        SessionStorage.setObject('app-storage', (responseData(response?.data) || '{}'));
        set({ appStorage: responseData(response?.data) })
    },
    CheckIsLifeScienceCustomerAction: async (id: number) => {
        const response = await GetBookingDetailsService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE && response?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const product = response?.data?.data;
            const isLifeScience = Array.isArray(product)
                ? product.some((p: any) => LIFE_SCIENCE_PRODUCT_IDS?.includes(p?.productId))
                : false;
            SessionStorage.setObject('isLifeScienceCustomer', isLifeScience);
            set({ isLifeScienceCustomer: isLifeScience });
        }

    },
    ClearLoginStore: () => set(initialValue)
}))


export const useLoginStore = (LoginStore)